import styled from 'styled-components';

import THEME from '../../../../../constants/theme';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Subtitle = styled.p`
  color: ${THEME.grey};
  font-family: Montserrat;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.43;
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const Text = styled.p`
  color: ${THEME.bobBlack};
  font-family: Montserrat;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.43;
  margin: 0;
`;
